/**
 * 數字輸入欄的取值（批106）。
 *
 * ## 為什麼需要這支
 *
 * Vue 3 對 `<input type="number">` 會**自動套用 `.number` 修飾子**
 * （`runtime-dom` 的 `vModelText`：`castToNumber = number || el.type === 'number'`），
 * 所以綁在上面的 ref **一打字就從字串變成數字**——但初值多半是 `''`（字串），
 * 載入時看起來一切正常。於是「`X.trim() ? Number(X) : null`」這種寫法會在
 * 使用者輸入的那一刻炸成 `TypeError: X.trim is not a function`，而且因為它多半
 * 寫在 computed 裡，一炸就是整塊表單連鎖失效（批106 的三張回報單全是這個根因）。
 *
 * 值域轉換規則刻意與原本的寫法**逐位元相同**：
 *
 * - 空白（`''`、`'   '`、`null`、`undefined`）→ `null`＝「留空」，語意由後端決定
 *   （留空＝客製／不限／依核發時選擇）。
 * - 數字或數字字串 → `number`。
 * - **非數字字串 → `null`**（不是 `NaN`）：`type="number"` 的輸入框在使用者打了
 *   `12e` 這種半成品時，瀏覽器回報的值就是空字串；真要漏進來一個 `NaN`，送到後端
 *   會變成 `null` 以外的 JSON 值（`NaN` 不是合法 JSON），錯在網路層比錯在畫面上難查。
 */
export function numOrNull(v: unknown): number | null {
  if (v === null || v === undefined) return null
  if (typeof v === 'number') return Number.isFinite(v) ? v : null
  const s = String(v).trim()
  if (!s) return null
  const n = Number(s)
  return Number.isFinite(n) ? n : null
}

/** 同 `numOrNull`，但空白／無效時回 `fallback`（用在「一定要有值」的欄位）。 */
export function numOr(v: unknown, fallback: number): number {
  const n = numOrNull(v)
  return n === null ? fallback : n
}

/** 數字欄是否「留白」（含只打了空白字元）。給 UI 判斷要不要提示補值。 */
export function isBlankNum(v: unknown): boolean {
  return numOrNull(v) === null
}
